import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ProgrammingCategoryRatingModuleName } from '@/store/modules/modules'

export class ProgrammingCategoryRatingViewModel {
  private store = useStore()

  chartData: ComputedRef<{ labelChartData: string[][]; categoryRatingChartData: number[][]; maxRating: number }> =
    computed(() => this.store.getters[`${ProgrammingCategoryRatingModuleName}/chartData`])
  chartSeries: ComputedRef<any[]> = computed(
    () => this.store.getters[`${ProgrammingCategoryRatingModuleName}/chartSeries`]
  )
  chartOptions: ComputedRef<any> = computed(
    () => this.store.getters[`${ProgrammingCategoryRatingModuleName}/chartOptions`]
  )
  hasData: ComputedRef<boolean> = computed(() => this.store.getters[`${ProgrammingCategoryRatingModuleName}/hasData`])

  setChartData(chartData: {
    labelChartData: string[][]
    categoryRatingChartData: number[][]
    maxRating: number
  }): void {
    this.store.commit(`${ProgrammingCategoryRatingModuleName}/setChartData`, chartData)
  }

  setChartSeries(chartSeries: any[]): void {
    this.store.commit(`${ProgrammingCategoryRatingModuleName}/setChartSeries`, chartSeries)
  }

  setChartOptions(chartOptions: any): void {
    this.store.commit(`${ProgrammingCategoryRatingModuleName}/setChartOptions`, chartOptions)
  }

  setHasData(hasData: boolean): void {
    this.store.commit(`${ProgrammingCategoryRatingModuleName}/setHasData`, hasData)
  }
}
